import * as React from 'react';

import { Checkbox, SortableTable } from '@coursera/coursera-ui';

import _t from 'i18n!nls/enterprise-admin-users';

export const SELECT_COLUMN_WIDTH = 55;

export type Row = {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
};

export type Column = {
  accessor: string;
  header: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  cellRenderer?: (cell: any, row: any, rowIndex: number) => string | number | JSX.Element | null; // eslint-disable-line @typescript-eslint/no-explicit-any
  width?: string;
};

export type TableProps = {
  rows: Array<Row>;
  rowStyle: (options: { isDark: boolean }) => { backgroundColor: string };
  selectAll: boolean;
  selectedIds: string[];
  columns: Column[];
  onSelectChange: (selectedIds: string[], selectAll: boolean) => void;
  withSelectAll?: boolean;
};

type State = {
  shouldRender: boolean;
};

class TableWithCustomSelection extends React.Component<TableProps, State> {
  state = {
    shouldRender: true,
  };

  componentDidUpdate = (prevProps: TableProps) => {
    const { columns } = this.props;
    // Table breaks if columns are added or subtracted
    // This is used to unmount and mount the table when that happens
    if (prevProps.columns.length !== columns.length) {
      this.setState({ shouldRender: false }, () => {
        this.setState({ shouldRender: true });
      });
    }
  };

  handleSelectingRow = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rowId = e.target.value;
    const { selectedIds, onSelectChange } = this.props;
    onSelectChange([...selectedIds, rowId], false);
  };

  handleDeselectingRow = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rowId = e.target.value;
    const { selectedIds, onSelectChange } = this.props;
    onSelectChange(
      selectedIds.filter((id) => id !== rowId),
      false
    );
  };

  handleSelectAll = () => {
    const { onSelectChange } = this.props;
    onSelectChange([], true);
  };

  getColumns = () => {
    const { columns, rows, withSelectAll = true } = this.props;
    return [
      {
        accessor: 'select',
        header: withSelectAll && (
          <Checkbox disabled={rows.length === 0} checked={false} onChange={this.handleSelectAll} />
        ),
        cellRenderer: this.renderRowSelect,
        width: `${SELECT_COLUMN_WIDTH}px`,
      },
      ...columns,
    ];
  };

  renderRowSelect = (id: string) => {
    const { selectAll, selectedIds } = this.props;
    const isRowSelected = selectedIds.includes(id);
    const onChangeFn = isRowSelected ? this.handleDeselectingRow : this.handleSelectingRow;
    const checked = selectAll || isRowSelected;
    return (
      <Checkbox
        value={id}
        disabled={selectAll}
        checked={checked}
        onChange={onChangeFn}
        ariaLabel={checked ? _t('Unselect learner') : _t('Select learner')}
      />
    );
  };

  render() {
    const { rows, rowStyle } = this.props;
    const { shouldRender } = this.state;
    return shouldRender && <SortableTable columns={this.getColumns()} rows={rows} rowStyle={rowStyle} />;
  }
}

export default TableWithCustomSelection;
